/**
 formats seconds into MM:SS type
 */
export const formatTime = (seconds: number) => {
	const normalizedSeconds = Math.max(0, seconds)
	let minutesToShow: string = String(Math.floor(normalizedSeconds / 60))
	if (minutesToShow == '0') {
		minutesToShow = '00'
	} else if (Number(minutesToShow) < 10) {
		minutesToShow = '0' + minutesToShow
	}

	let secondsToShow: string = String(Math.ceil(normalizedSeconds % 60))
	if (secondsToShow == '0') {
		secondsToShow = '00'
	} else if (Number(secondsToShow) < 10) {
		secondsToShow = '0' + secondsToShow
	}
	return `${minutesToShow}:${secondsToShow}`
}

/**
 * Return current time in format HH:MM
 */
export const getCurrentTime = (): string => {
	const now: Date = new Date()
	const hours: string = String(now.getHours()).padStart(2, '0')
	const minutes: string = String(now.getMinutes()).padStart(2, '0')
	return `${hours}:${minutes}`
}

/**
 * Convert a given ISO date string to time in format HH:MM
 * @param isoDateString - Date string in ISO format (e.g., "2024-12-24T21:22:34.856242")
 * @returns Time in format HH:MM
 */
export const getTimeWithGMT3 = (isoDateString: string): string => {
	// Create a Date object from the ISO string
	const date: Date = new Date(isoDateString)

	// Add 3 hours to the date
	date.setHours(date.getHours() + 3)

	// Extract hours and minutes, and pad them with leading zeros if necessary
	const hours: string = String(date.getHours()).padStart(2, '0')
	const minutes: string = String(date.getMinutes()).padStart(2, '0')

	// Return the formatted time
	return `${hours}:${minutes}`
}
